import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { ReporteGeneralService } from '../../services/reporte-general.service';
import { ConfirmModalComponent } from './../tools/modals/confirm-modal/confirm-modal.component';
import { AutenticacionService } from '../../services/autenticacion.service';
import {ObrasService} from "../../services/obras.service";
import { ReporteLiquidacionService } from '../../services/reporte-liquidacion.service';


@Component({
  selector: 'app-reporte-liquidacion-comprobante',
  templateUrl: './reporte-liquidacion-comprobante.component.html',
  styleUrls: ['./reporte-liquidacion-comprobante.component.scss']
})
export class ReporteLiquidacionComprobanteComponent implements OnInit {
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  protected reporte_selected: any = {};
  protected inversionista_selected: any = {};
  array_inversionista_selected: any=[];
  protected reporte_selected_id: any;
  protected liquidaciones_list: any[];
  protected list_email_cco: string;

  protected processing: boolean;
  protected sending: boolean;
  protected saving: boolean; 

  private list_send_email: any[] = [];
  private idLiquidacion:any;
  liquidacion_selected: any = {};
  primera_seleccion: boolean = true;

  obraFilter: any = {};
  cargandoTabla: any = 'starting';
  inversionistas: any = 'starting';
  grupoInversionista: any = 'starting';
  loading:any= true;
  lodingInformacionInversionista:boolean = false;
  validarEmail: any='starting';
  validarNotasIniciales: any='starting';
  validarNotasInicialesLongitud: any='starting';
  validarNotasFinales: any='starting';
  validarNotasFinalesLongitud: any='starting';
  errors: any;
  notasIniciales:any="";
  notasFinales:any="";
  notasInicialesGuardar:any="";
  notasFinalesGuardar:any="";
  sendEmail:any;
  arrayInversionistas:any = [];
  arrayInversionistasGrupos:any = [];
  arrayInversionistasList:any = [];
  cobranza:any = 0;
  emailCCO:any;
  retencionTotal:any;
  conceptos:any;
  ingreso:any;
  egreso:any;
  resultadoBruto:any;
  resultadoBrutoConFormato:any = "";
  validarInversionistasList:any='starting';
  arrayRetornoHistorico:any[] = [];
  arrayfechasHistorico:any[] = [];
  tabla:any[] = [];
  total:any;
  resultadoFinal:any;
  aniospuntoEquilibrio:any ;
  retornopuntoEquilibrio : any;
  aportacionpuntoEquilibrio: any;

  nombreObra:any;
  fechaObra:any;
  retornoHistorico:any = {};
  puntoEquilibrio:any = {};
  
  public idReporteLiquidacion:any;
  public hash:any;
  public token:any;
  printing: boolean = false;


  constructor(private reporteLiquidacionService: ReporteLiquidacionService,
    private reporteGeneralService: ReporteGeneralService,
    private router: Router, private activedRoute: ActivatedRoute,
    private helpersService: HelpersService, private sanitizer: DomSanitizer,
    private authService: AutenticacionService,private obrasService: ObrasService,
    private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.getDatosComprobante();
    //this.getLiquidacionesList();
    //this.startCuentaSelected();
  }

  startReporteSelected() {
    this.array_inversionista_selected = this.reporteGeneralService.getDefaultScheduleInversionistas();
  }

  getDatosComprobante() {
    this.hash = this.route.snapshot.queryParams["hash"];
    this.token = this.route.snapshot.queryParams["token"];
    if (this.token) {
      this.getReporteInversionista(this.token);
    } else {
    }
  }


  getReporteInversionista(inv) {
    this.array_inversionista_selected = [];
    if(Object.keys(inv).length !== 0)
    {
      this.lodingInformacionInversionista = true;
      this.array_inversionista_selected.imagen = "";
        this.reporteGeneralService.getReporteInversionista(inv)
        .subscribe((response => {
          // agregar la lógica al recibir la info del inv seleccionado
          const content_response = response.json().content;
          this.array_inversionista_selected = content_response;
          this.array_inversionista_selected.obras = content_response.obras;
          this.array_inversionista_selected.liquidacion = content_response.liquidacion;
          this.array_inversionista_selected.resultados = content_response.resultados;
          this.array_inversionista_selected.retornosHistoricos = content_response.retornosHistoricos;
          this.array_inversionista_selected.fondoAhorro = content_response.fondoAhorro;
          this.array_inversionista_selected.ingresos = content_response.ingresos;
          this.array_inversionista_selected.egresos = content_response.egresos;
          this.array_inversionista_selected.imagenes = content_response.imagenes;
          this.total = content_response.reporteRentabilidad.total;
          this.tabla = content_response.reporteRentabilidad.tabla;
          this.puntoEquilibrio = content_response.puntoEquilibrio;
          this.retornoHistorico = this.array_inversionista_selected.retornosHistoricos;
          
          if (this.array_inversionista_selected.imagenes.length > 0) {
            this.loadFotografia(0);
          }
          this.getReporteImagenObra(this.array_inversionista_selected.obras.idObras);
          this.lodingInformacionInversionista = false;
        }));
      
    }
  }

  getReporteImagenObra(data) {
      this.reporteGeneralService.getImageUrl(data).subscribe(response => {
        const unsave_url = window.URL.createObjectURL(response.blob());
        this.array_inversionista_selected.imagen = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
      });
  }

  loadFotografia(posicion) {
    let inversionista = this.array_inversionista_selected.imagenes[posicion];
    if (inversionista.nombre) {
      this.reporteGeneralService.getReporteImagen(inversionista.idLiquidacion_Imagenes).subscribe(response => {
         const unsave_url = window.URL.createObjectURL(response.blob());
        inversionista.imageInversionista = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
      });
      if (this.array_inversionista_selected.imagenes.length -1  > posicion) {
        this.loadFotografia(posicion+1);
      }
    } else {
        if (this.array_inversionista_selected.imagenes.length -1  > posicion) {
            this.loadFotografia(posicion+1);
        }
    }
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      this.printing = false;
    };
  }

  calculateRetention(mode = 0,amount,rentaConIva,porcentaje){
    return this.reporteLiquidacionService.calculateRetention(mode, amount,rentaConIva,porcentaje);
  }
  
  getRentaConIva(){
    let acumulado = 0.0;
    if(!this.array_inversionista_selected.ingresos){
      return acumulado;
    }
    this.array_inversionista_selected.ingresos.forEach((ingreso)=> {
      if(ingreso.idConceptos == 818 ){
        //El valor del importe necesita convertirse en un number para que se sume correctamente
        acumulado = acumulado + Number(ingreso.importe_value);
      }
    });
    return acumulado;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-liquidacion-comprobante/reporte-liquidacion-comprobante.component.ts